/**
 * Possible profile names
 */
export enum AppProfileNames {
	adminProfileFull = "adminProfileFull",
	appNone = "appNone",
	appBasicPlan = "appBasicPlan",
	appMasterPlan = "appMasterPlan"
}
